import React, { useState, useEffect } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import Cookies from "js-cookie";
import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  Container,
  Grid,
} from "@mui/material";

function SignIn() {
  const [formData, setFormData] = useState({
    username_or_email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    username_or_email: "",
    password: "",
    other: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear errors as user types
  };
  // Redirect if already logged in
  useEffect(() => {
    const token = Cookies.get("prgiToken");
    if (token) {
      navigate("/title-registration", { replace: true }); // Redirect to a default protected route
    }
  }, [navigate]);

  const validate = () => {
    let isValid = true;
    let newErrors = { username_or_email: "", password: "" };

    if (!formData.username_or_email) {
      newErrors.username_or_email = "Email is required";
      isValid = false;
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const formDetails = new URLSearchParams();
    formDetails.append("username", formData.username_or_email);
    formDetails.append("password", formData.password);

    try {
      const response = await fetch(
        "https://ajayreddy9-prgi.hf.space/auth/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formDetails,
        }
      );

      setLoading(false);

      if (response.ok) {
        const data = await response.json();
        // Store token in cookies
        Cookies.set("prgiToken", data.access_token, { expires: 1 }); // Expires in 1 day
        navigate("/title-registration", { replace: true });
      } else {
        const errorData = await response.json();
        setErrors({
          ...errors,
          other: errorData.detail || "Authentication failed!",
        });
      }
    } catch (error) {
      setLoading(false);
      setErrors({
        ...errors,
        other: "An error occurred. Please try again later.",
      });
    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 4,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Sign In
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Username/Email"
            name="username_or_email"
            margin="normal"
            fullWidth
            value={formData.username_or_email}
            onChange={handleChange}
            error={Boolean(errors.username_or_email)}
            helperText={errors.username_or_email}
          />
          <TextField
            label="Password"
            name="password"
            type="password"
            margin="normal"
            fullWidth
            value={formData.password}
            onChange={handleChange}
            error={Boolean(errors.password)}
            helperText={errors.password}
          />
          {errors.other !== "" && <p>{errors.other}</p>}
          {!loading && (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2, mb: 2 }}
            >
              Sign In
            </Button>
          )}
          {loading && (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2, mb: 2 }}
            >
              Working
            </Button>
          )}
        </form>
        <Grid container>
          <Grid item>
            <Link component={RouterLink} to="/signup" variant="body2">
              {"Don't have an account? Sign Up"}
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default SignIn;
